var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pencil",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9517,21.7559 L1.1867,28.8129 L8.2437,27.0479 L27.6467,7.6469 C28.0867,7.2069 28.3967,6.6619 28.4977,6.1519 C28.6027,5.6289 28.4837,5.1919 28.1467,4.8539 L25.1467,1.8539 C24.4777,1.1859 23.2437,1.4629 22.3537,2.3539 L2.9517,21.7559 Z M0.4997,29.9999 C0.3687,29.9999 0.2417,29.9479 0.1467,29.8539 C0.0227,29.7299 -0.0283,29.5489 0.0147,29.3789 L2.0147,21.3789 C2.0367,21.2909 2.0827,21.2109 2.1467,21.1469 L21.6467,1.6469 C22.9337,0.3599 24.8077,0.0999 25.8537,1.1469 L28.8537,4.1469 C29.4257,4.7179 29.6477,5.4999 29.4787,6.3479 C29.3387,7.0559 28.9387,7.7689 28.3537,8.3539 L8.8537,27.8539 C8.7897,27.9179 8.7087,27.9629 8.6207,27.9849 L0.6207,29.9849 C0.5807,29.9949 0.5407,29.9999 0.4997,29.9999 L0.4997,29.9999 Z",
    id: "Fill-2876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,9 C27.372,9 27.244,8.951 27.146,8.854 L21.146,2.854 C20.951,2.658 20.951,2.342 21.146,2.146 C21.342,1.951 21.658,1.951 21.854,2.146 L27.854,8.146 C28.049,8.342 28.049,8.658 27.854,8.854 C27.756,8.951 27.628,9 27.5,9",
    id: "Fill-2877"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,10.5 C25.872,10.5 25.744,10.451 25.646,10.354 L19.646,4.354 C19.451,4.158 19.451,3.842 19.646,3.646 C19.842,3.451 20.158,3.451 20.354,3.646 L26.354,9.646 C26.549,9.842 26.549,10.158 26.354,10.354 C26.256,10.451 26.128,10.5 26,10.5",
    id: "Fill-2878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,28 C8.372,28 8.244,27.951 8.146,27.854 L2.146,21.854 C1.951,21.658 1.951,21.342 2.146,21.146 C2.342,20.951 2.658,20.951 2.854,21.146 L8.854,27.146 C9.049,27.342 9.049,27.658 8.854,27.854 C8.756,27.951 8.628,28 8.5,28",
    id: "Fill-2879"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.90a8124e34b0906bf2a2b8d06bb99f68.svg";
export { ForwardRef as ReactComponent };